import { ConsoleLogger } from '@skylab-shared/core';

export interface ListFilterSettings {
    pattern: string;
}

export interface ListPaginationSettings {
    pageNumber: number;
    pageSize: number;
}

export const defaultQLSettings = {
    filterSettings: {
        pattern: ''
    },
    paginationSettings: {
        pageNumber: 0,
        pageSize: 10,
    }
};

export type DataSet = typeof defaultQLSettings;

export type FilterMethod<T> = (filterSettings: ListFilterSettings, paginationSettings: ListPaginationSettings) => Promise<T[]>;

export const SearchDelay = 400;

interface Config<T> {
    filterMethod: FilterMethod<T>;
    settings: Partial<DataSet>;
}

export class QuickListService {
    private readonly logger: ConsoleLogger = new ConsoleLogger();
    public filterMethod!: FilterMethod<any>;
    public settings!: Partial<DataSet>;

    public config<T>({filterMethod, settings}: Config<T>): void {
        this.filterMethod = filterMethod;
        this.settings = settings;
    }

    public async loadData({
            pattern = defaultQLSettings.filterSettings.pattern,
            page = defaultQLSettings.paginationSettings.pageNumber
        }): Promise<any[]> {
        const settings = this.initSettings();
        const searchPattern = {
            filterSettings: {
                pattern: pattern
            },
            paginationSettings: {
                pageNumber: page,
                pageSize: settings.paginationSettings.pageSize
            }
        };
        Object.assign(settings, searchPattern);
        const data = await this.initData(settings);

        return data ? [...data] : [];
    }

    protected async initData({ filterSettings, paginationSettings }: DataSet): Promise<any[]> {
        try {
            const result = await this.filterMethod(filterSettings, paginationSettings);
            return result;
        } catch (error) {
            this.logger.error(`can't resolve data -> ${ error }`);
            return [];
        }
    }

    protected initSettings(): DataSet {
        return Object.assign<{}, DataSet, Partial<DataSet>>({}, defaultQLSettings, this.settings);
    }
}
